import React, {useEffect, useState} from 'react';
import {
   View,
   Text,
   Image,
   TouchableOpacity,
   Modal,
   ScrollView,
   StatusBar,
   Platform,
} from 'react-native';
import {
   FONT_FAMILY_REGULAR,
   FONT_FAMILY_BOLD,
   BACK_BUTTON_HOVER_COLOR,
   WHITE_ICON_HOVER_TINT_COLOR,
   isMacOS,
} from '../../utils/utils';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';

const ReviewAnswerResponseScreen = props => {
   const {isCorrect, correctResponse, incorrectResponse} = props;
   const [answerHeader, setAnswerHeader] = useState('');
   const isLandscapemode = useSelector(selectScreenOrientation);
   const isMacos = Platform.OS === 'macos';
   const [isHover, setHover] = useState(false);
   useEffect(() => {
      handleAnswerResponse();
   });
   function handleAnswerResponse() {
      if (isCorrect) {
         setAnswerHeader(correctResponse);
      } else {
         if (incorrectResponse == '') {
            setAnswerHeader(
               'Sorry, The answer you selected is not the correct answer. Please try again:',
            );
         } else {
            setAnswerHeader(incorrectResponse);
         }
      }
   }
   const isWeb = Platform.OS === 'web';
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const popupPadding = isLandscapemode ? 48 : 20;
   return (
      <View
         statusBarTranslucent
         animationType="fade"
         transparent
         style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            ...Platform.select({
               web: {
                  zIndex: 1000,
                  transform: 'translate3d(0, 0, 0)',
               },
            }),
         }}
         visible={true}
         supportedOrientations={['landscape']}>
         <View
            style={{
               flex: 1,
               backgroundColor: 'rgba(0, 0, 0, 0.6)',
               alignItems: 'center',
               justifyContent: 'center',
               ...Platform.select({
                  web: {
                     flex: null,
                     height: '100%',
                     width: '100%',
                     minHeight:
                        !isLandscapemode && !isLandscapeSmallWebView
                           ? null
                           : '98vh',
                     minWidth:
                        !isLandscapemode && !isLandscapeSmallWebView
                           ? null
                           : '98vw',
                  },
               }),
            }}>
            <View
               style={{
                  width: '50%',
                  height: isLandscapemode ? 440 : 250,
                  alignItems: 'center',
                  backgroundColor: '#202020',
                  borderRadius: 6,
                  ...Platform.select({
                     web: {
                        height: isLandscapemode ? 376 : 248,
                        width: '451px',
                        maxHeight:
                           !isLandscapemode && !isLandscapeSmallWebView
                              ? '40vh'
                              : '78vh',
                        maxWidth: '96vw',
                        marginBottom: isLandscapeSmallWebView ? 64 : null,
                     },
                     macos: {
                        height: '52%',
                        width: '40%',
                     },
                  }),
               }}>
               <Image
                  source={
                     isCorrect
                        ? require('../../assets/correct.png')
                        : require('../../assets/incorrect.png')
                  }
                  style={{
                     width: isLandscapemode ? 64 : 30,
                     height: isLandscapemode ? 64 : 30,
                     marginTop: popupPadding,
                  }}
               />
               <Text
                  style={{
                     color: isCorrect ? '#26E555' : '#F00',
                     fontFamily: FONT_FAMILY_BOLD,
                     fontSize: isLandscapemode ? 32 : 24,
                     fontWeight: isLandscapemode ? '700' : '600',
                     marginTop: isWeb ? 16 : isLandscapemode ? 16 : 8,
                  }}>
                  {isCorrect ? 'Correct' : 'Incorrect'}
               </Text>
               <View
                  style={{
                     height: '25%',
                     marginBottom: 40,
                  }}>
                  <ScrollView>
                     <Text
                        style={{
                           color: '#8897AE',
                           fontFamily: FONT_FAMILY_REGULAR,
                           fontSize: isLandscapemode ? 20 : 14,
                           marginTop: isLandscapemode ? 16 : 10,
                           marginLeft: isLandscapemode ? 48 : 24,
                           marginRight: isLandscapemode ? 48 : 20,
                           textAlign: 'center',
                           fontWeight: '500',
                        }}>
                        {answerHeader.replace(
                           isMacOS ? /\u0019/g : '\u0019',
                           "'",
                        )}
                     </Text>
                  </ScrollView>
               </View>

               <TouchableOpacity
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  style={{
                     position: 'absolute',
                     bottom: 0,
                     marginBottom: popupPadding,
                     width: isLandscapemode ? '40%' : '25%',
                     height: isLandscapemode ? '14%' : '15%',
                     backgroundColor: isHover
                        ? WHITE_ICON_HOVER_TINT_COLOR
                        : '#FFFFFF',
                     borderRadius: 6,
                     borderColor: '#4A72FF',
                     borderWidth: 1.75,
                     justifyContent: 'center',
                     alignItems: 'center',
                     ...Platform.select({
                        web: {
                           width: 182,
                           height: 56,
                           //marginBottom: 28,
                        },
                     }),
                  }}
                  onPress={() => {
                     props.onClose();
                  }}>
                  <View
                     style={{
                        flexDirection: isCorrect ? 'row-reverse' : 'row',
                        alignItems: 'center',
                     }}>
                     <Image
                        source={
                           isCorrect
                              ? require('../../assets/next_arrow_retry.png')
                              : require('../../assets/back_arrow_retry.png')
                        }
                        style={{
                           width: 12,
                           height: 12,
                           marginLeft: isCorrect ? 5 : 0,
                        }}
                     />
                     <Text
                        style={{
                           color: '#003DA5',
                           fontFamily: FONT_FAMILY_BOLD,
                           fontSize: isLandscapemode ? 20 : 14,
                           fontWeight: isLandscapemode ? '600' : '700',
                           marginLeft: isCorrect ? 0 : 5,
                        }}>
                        {isCorrect ? 'Next' : 'Retry'}
                     </Text>
                  </View>
               </TouchableOpacity>
            </View>
         </View>
      </View>
   );
};

export default ReviewAnswerResponseScreen;
